import React from "react";
import { connect } from "react-redux";
import ConsoleView from "./ConsoleView.js";
import ArenaView from "./ArenaView.js";
import audioManager from "../_audio/audio-manager.js";
import {setBattleValue} from "../redux-actions/battle-actions";
import FullscreenState from '../b5-home/FullscreenState'

/** Sets any data before mounting the battle arena */
class OnlineBattleContainer extends React.Component {
  componentDidMount() {

    //NOTE: this happens separately in Offline play via OfflineBattleContainer
    setBattleValue({
      battleStartTimestamp: Date.now(), //Start time!
    });


    //Play the music! TODO: maybe move me
    audioManager.playSong("music_RegularBattle");
  }

  render() {
    if (this.props.isBrowserBot) {
      //I do not believe this state will ever occur.
      //Now with rejoining, the player should be able to resume control of his or her character.
      //Leaving this here just in case.
      return (
        <FullscreenState>
          <div>
            <p className="ErrorStateText__text">Oh no! Your combatant is now a Bot in the match.</p>
            <div>
              <a className="button large" href="/">Go to Your Crew</a>
            </div>
          </div>
        </FullscreenState>
      );
    }

    if (this.props.battleViewMode === "arena") {
      return <ArenaView />;
    }

    //Leaving this here in the event you want ConsoleView for online play
    return <ConsoleView />;
  }
}

export default connect((state, props) => {
  const playerCombThatIsNowABot = state.battle.battlePlayerId.find(id => {
    return state.battle.combatants[id] && state.battle.combatants[id].isBot;
  });

  return {
    battleViewMode: state.battle.battleViewMode,
    isBrowserBot: Boolean(playerCombThatIsNowABot)
  };
})(OnlineBattleContainer);



// WEBPACK FOOTER //
// ./src/battle/OnlineBattleContainer.js